import React from "react";

function ProductStatus({
    formData,
    handleChange
}) {
    return (
        <div className="card mb-3">
            <div className="card-header">
                <h5>Status</h5>
            </div>
            <div className="card-body">
                <select
                    className="form-control"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                >
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                </select>
            </div>
        </div>
    );
}

export default ProductStatus;